export const firebaseConfig = {
    apiKey: "AIzaSyBHD8gzvN8fySV4mHbl-QFDyUabbkFXRKs",
    authDomain: "unops-pharmamxapp-dev.firebaseapp.com",
    projectId: "unops-pharmamxapp-dev",
    storageBucket: "unops-pharmamxapp-dev.appspot.com",
    messagingSenderId: "434335049737",
    appId: "1:434335049737:web:54b63b83061aee93abb0d8",
    measurementId: "G-YE2XGF0YB6"
  };